import { useState } from "react";
import { login as loginService } from "../../services/authService";
import { useAuth } from "../../context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const [error, setError] = useState("");

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    try {
      const token = await loginService(email, password);
      login(token);
      window.location.href = "/admin/blogs";
    } catch {
      setError("Invalid email or password");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-24 p-8 border rounded-xl shadow">
      <h1 className="text-2xl font-bold mb-4">Admin Login</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">

        <input type="email" placeholder="Email"
          className="border p-3 rounded"
          onChange={(e) => setEmail(e.target.value)} />

        <input type="password" placeholder="Password"
          className="border p-3 rounded"
          onChange={(e) => setPassword(e.target.value)} />

        {error && <p className="text-red-500">{error}</p>}

        <button className="bg-pink-600 text-white p-3 rounded hover:opacity-80">
          Login
        </button>
      </form>
    </div>
  );
}